const Hip_questions = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"F[0].Page-1[0].Public2507Questions[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"F[0].Page-1[0].Public2507Questions[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page-1[0].Public2507Questions[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "EVIDENCE REVIEW",
         number: "0"
      },
      "presidence":"Yes",
      "maxLength":105,
      "radioGroup":"F[0].Page-1[0].PublicEvidenceReview[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"F[0].Page-1[0].PublicEvidenceReview[0].IdentifyEvidence[0]",
      "textanswer":""
   },
   {
      "question":"Does ##name##'s treatment plan include taking continuous medication for the diagnosed condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "2",
         title: "MEDICAL HISTORY",
         number: "2B"
      },
      "radioGroup":"F[0].Page_2[0].RadioButtonList[0]",
      "presidence":"Yes",
      "maxLength":90,
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "List medications taken for the male reproductive organ condition",
      "textdbqName":"F[0].Page_2[0].Listmedications[0]",
      "textanswer":""
   },
   {
      "question":"Has ##name## had an orchiectomy?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "2",
         title: "MEDICAL HISTORY",
         number: "2C"
      },
      "radioGroup":"F[0].Page_2[0].RadioButtonList[1]",
      "presidence":"Yes",
      "ref":2,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Indicate testicle removed",
      "sub":"",
      "type":"radio",
      "show": false,
      "refId":1,
      "section": {
         page: "2",
         title: "MEDICAL HISTORY",
         number: "2C"
      },
      "questions":[
         {
            "label":"Indicate side",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"F[0].Page_2[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"Right",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Left",
                  "dbqName":"2",
                  "sub":""
               },
               {
                  "main":"Both",
                  "dbqName":"3",
                  "sub":""
               }
            ],
            "answer":"No"
         }
      ]
   },
   {
      "question":"Indicate reason for removal?",
      "sub":"",
      "type":"radioTiles",
      "multi": false,
      "show": false,
      "refId":2,
      "small": true,
      "cols": 2,
      "section": {
         page: "2",
         title: "MEDICAL HISTORY",
         number: "2C"
      },
      "questions":[
         {
            "main":"Undescended",
            "dbqName":"F[0].Page_2[0].CheckBox51[0]",
            "answer":""
         },
         {
            "main":"Congenitally underdeveloped",
            "dbqName":"F[0].Page_2[0].CheckBox52[0]",
            "answer":""
         },
         {
            "main":"Other, provide reason for removal",
            "dbqName":"F[0].Page_2[0].CheckBox53[0]",
            "answer":"",
            "textarea": true,
            "maxLength":90,
            "textdbqName" : "F[0].Page_2[0].ProvideReason[0]",
            "placeholder": "describe in the functional loss",
            "textAnswer": ""
         }          
      ],
      "answer":""
   },
   {
      "question":"Is there any renal dysfunction due to any conditions listed in the diagnosis section?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "MEDICAL HISTORY",
         number: "2D"
      },
      "radioGroup":"F[0].Page_3[0].RadioButtonList[0]",
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":""
   },
   {
      "question":"Does ##name## have voiding dysfunction?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "VOIDING DYSFUNCTION",
         number: "3A"
      },
      "radioGroup":"F[0].Page_3[0].RadioButtonList[1]",
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Etiology of voiding dysfunction",
      "sub":"",
      "type":"textarea",
      "maxLength":60,
      "show": true,
      "section": {
         page: "3",
         title: "VOIDING DYSFUNCTION",
         number: "3B"
      },
      "options":[],
      "dbqName":"F[0].Page_3[0].TextField27[0]",
      "answer":""
   },
   {
      "question":"Does the voiding dysfunction cause urine leakage?",
      "sub":"",
      "type":"radioTiles",
      "multi": false,
      "show": true,
      "small": true,
      "cols": 2,
      "radioGroup":"F[0].Page_3[0].RadioButtonList[6],F[0].Page_3[0].RadioButtonList[2]",
      "section": {
         page: "3",
         title: "VOIDING DYSFUNCTION",
         number: "3C"
      },
      "questions":[
         {
            "main":"Does not require the wearing of absorbent materia",
            "dbqName":"1,1",
            "answer":""
         },
         {
            "main":"Requires absorbent material which must be changed less than 2 times per day",
            "dbqName":"2,1",
            "answer":""
         },
         {
            "main":"Requires absorbent material which must be changed 2 to 4 times per day",
            "dbqName":"3,1",
            "answer":""
         },
         {
            "main":"Requires absorbent material which must be changed more than 4 times per day",
            "dbqName":"4,1",
            "answer":""
         },
         {
            "main":"No urine leakage",
            "dbqName":",2",
            "answer":""
         }            
      ],
      "answer":""
   },
   {
      "question":"Does the voiding dysfunction require the use of an appliance?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "VOIDING DYSFUNCTION",
         number: "3D"
      },
      "radioGroup":"F[0].Page_3[0].RadioButtonList[3]",
      "presidence":"Yes",
      "maxLength":105,
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please describe the appliance",
      "textdbqName":"F[0].Page_3[0].TextField45[0]",
      "textanswer":""
   },
   {
      "question":"Does the voiding dysfunction cause increased urinary frequency?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "VOIDING DYSFUNCTION",
         number: "3E"
      },
      "radioGroup":"F[0].Page_3[0].RadioButtonList[4]",
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Indicate the increased urinary frequency",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "3",
         title: "VOIDING DYSFUNCTION",
         number: "3E"
      },
      "questions":[
         {
            "main":"Daytime voiding interval between 2 and 3 hours",
            "dbqName":"F[0].Page_3[0].CheckBox45[0]",
            "answer":""
         },
         {
            "main":"Daytime voiding interval between 1 and 2 hours",
            "dbqName":"F[0].Page_3[0].CheckBox46[0]",
            "answer":""
         },
         {
            "main":"Daytime voiding interval less than 1 hour",
            "dbqName":"F[0].Page_3[0].CheckBox47[0]",
            "answer":""
         },
         {
            "main":"Nighttime awakening to void 2 times",
            "dbqName":"F[0].Page_3[0].CheckBox48[0]",
            "answer":""
         },
         {
            "main":"Nighttime awakening to void 3 to 4 times",
            "dbqName":"F[0].Page_3[0].CheckBox49[0]",
            "answer":""
         },
         {
            "main":"Nighttime awakening to void 5 or more times",
            "dbqName":"F[0].Page_3[0].CheckBox50[0]",
            "answer":""
         }        
      ],
      "answer":""
   },
   // {
   //    "question":"Does ##name## have erectile dysfunction?",
   //    "sub":"",
   //    "type":"radioTiles",
   //    "multi": false,
   //    "show": true,
   //    "small": true,
   //    "cols": 2,
   //    "radioGroup":"F[0].Page_4[0].RadioButtonList[4]",
   //    "section": {
   //       page: "4",
   //       title: "ERECTILE DYSFUNCTION",
   //       number: "4A"
   //    },
   //    "questions":[
   //       {
   //          "main":"Etiology is known",
   //          "dbqName":"1",
   //          "answer":"",
   //          "textarea": true,
   //          "textdbqName" : "F[0].Page_4[0].TextField49[0]",
   //          "placeholder": "Please provide etiology",
   //          "textAnswer": ""
   //       },
   //       {
   //          "main":"Etiology unknown",
   //          "dbqName":"2",
   //          "answer":""
   //       }         
   //    ],
   //    "answer":""
   // },

   {
      "question":"Does ##name## have erectile dysfunction?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "4",
         title: "ERECTILE DYSFUNCTION",
         number: "4A"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page_4[0].RadioButtonList[4]",
      "ref":1,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Is etiology known for erectile dysfunction?",
      "sub":"",
      "type":"yesno",
      "show": false,
      "section": {
         page: "4",
         title: "ERECTILE DYSFUNCTION",
         number: "4A"
      },
      "presidence":"Yes",
      "maxLength":105,
      "refId":1,
      "dbqName_yes":"pass_this_question",
      "dbqName_no":"F[0].Page_4[0].CheckBox34[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please provide etiology",
      "textdbqName":"F[0].Page_4[0].TextField49[0]",
      "textanswer":""
   },

   {
      "question":"Physical Exam-Penis",
      "sub":'A physical exam is not required. Select "Not examined, exam not relevant to condition" if you wish to skip.',
      "type":"radioModal",
      "multi": false,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "5",
         title: "PHYSICAL EXAM",
         number: "7A"
      },
      "questions":[
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_4[0].PenisExam[2]",
                  "answer":"",
               },
               {
                  "main":"Not examined per Veteran's request",
                  "dbqName":"F[0].Page_4[0].PenisExam[1]",
                  "answer":"",
               },
               {
                  "main":"Not examined, Veteran reports normal anatomy with no penile deformity or abnormality",
                  "dbqName":"F[0].Page_4[0].PenisExam[0]",
                  "answer":"",
               },
               {
                  "main":"Not examined, penis exam not relevant to condition",
                  "dbqName":"F[0].Page_4[0].PenisExam[3]",
                  "answer":"",
               },
               {
                  "main":"Abnormal",
                  "dbqName":"F[0].Page_4[0].PenisExam[4]",
                  "answer":"",
                  "multi": true,
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"Loss/removal of less than half",
                        "dbqName":"F[0].Page_4[0].LossPenis[1]",
                        "colWidth": 6,
                        "answer":""
                     },
                     {
                        "main":"Loss/removal of half or more",
                        "dbqName":"F[0].Page_4[0].LossPenis[0]",
                        "colWidth": 6,
                        "answer":""
                     },
                     {
                        "main":"Loss/removal of glans",
                        "dbqName":"F[0].Page_4[0].LossGlans[0]",
                        "colWidth": 6,
                        "answer":""
                     },
                     {
                        "main":"Penis deformity",
                        "dbqName":"F[0].Page_4[0].Deformity[0]",
                        "colWidth": 6,
                        "subItemLinked": true,
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Penis physical exam",
                  "subItemOther": false,
                  "textOther": "",
                  "dbqNameOther": "F[0].Page_4[0].TextField35[1]",
                  "placeholderOther":"Describe penis deformity",
               }                       
            ],
            "answer":""
   },
   {
      "question":"Physical Exam-Testes",
      "sub":'A physical exam is not required. Select "Not examined, exam not relevant to condition" if you wish to skip.',
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "5",
         title: "PHYSICAL EXAM",
         number: "7B"
      },
      "questions":[
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_5[0].TESTES[0]",
                  "answer":"",
                  "radioGroup":"F[0].Page_5[0].RadioButtonList[0]",
                  "multi": false,
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"Right",
                        "dbqName":"1",
                        "colWidth": 4,
                        "answer":""
                     },
                     {
                        "main":"Left",
                        "dbqName":"2",
                        "colWidth": 4,
                        "answer":""
                     },
                     {
                        "main":"Both",
                        "dbqName":"3",
                        "colWidth": 4,
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Penis physical exam",
               },
               {
                  "main":"Not examined per Veteran's request",
                  "dbqName":"F[0].Page_5[0].TESTES[1]",
                  "answer":"",
               },
               {
                  "main":"Not examined, testicular exam not relevant to condition",
                  "dbqName":"F[0].Page_5[0].TESTES[3]",
                  "answer":"",
               },
               {
                  "main":"Not examined, Veteran reports normal anatomy with no testicular deformity or abnormality",
                  "dbqName":"F[0].Page_5[0].TESTES[2]",
                  "answer":"",
               },
               {
                  "main":"Abnormal Right Testicle",
                  "dbqName":"F[0].Page_5[0].TESTES[4]",
                  "answer":"",
                  "multi": true,
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"Complete atrophy of",
                        "dbqName":"F[0].Page_5[0].LeftTesticle[7]",
                        "colWidth": 6,
                        "answer":""
                     },
                     {
                        "main":"Size 1/3 or less of normal",
                        "dbqName":"F[0].Page_5[0].RightTesticle[0]",
                        "colWidth": 6,
                        "answer":""
                     },                     
                     {
                        "main":"Considerably harder than the contralateral (corresponding) normal testicle",
                        "dbqName":"F[0].Page_5[0].RightTesticle[3]",
                        "colWidth": 12,
                        "answer":""
                     },
                     {
                        "main":"Considerably softer than the contralateral (corresponding) normal testicle",
                        "dbqName":"F[0].Page_5[0].RightTesticle[2]",
                        "colWidth": 12,
                        "answer":""
                     },
                     {
                        "main":"Size 1/2 or less, but more than 1/3 of normal",
                        "dbqName":"F[0].Page_5[0].RightTesticle[1]",
                        "colWidth": 8,
                        "answer":""
                     },
                     {
                        "main":"Absent",
                        "dbqName":"F[0].Page_5[0].RightTesticle[5]",
                        "colWidth": 4,
                        "answer":""
                     },
                     {
                        "main":"Other abnormality",
                        "dbqName":"F[0].Page_5[0].RightTesticle[4]",
                        "colWidth": 4,
                        "subItemLinked": true,
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Right Testicle physical exam",
                  "subItemOther": false,
                  "textOther": "",
                  "dbqNameOther": "F[0].Page_5[0].TextField35[3]",
                  "placeholderOther":"Describe other abnormality",
               },
               {
                  "main":"Abnormal Left Testicle",
                  "dbqName":"F[0].Page_5[0].TESTES[4]",
                  "answer":"",
                  "multi": true,
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"Complete atrophy of",
                        "dbqName":"F[0].Page_5[0].LeftTesticle[6]",
                        "colWidth": 6,
                        "answer":""
                     },
                     {
                        "main":"Size 1/3 or less of normal",
                        "dbqName":"F[0].Page_5[0].LeftTesticle[5]",
                        "colWidth": 6,
                        "answer":""
                     },
                     {
                        "main":"Size 1/2 or less, but more than 1/3 of normal",
                        "dbqName":"F[0].Page_5[0].LeftTesticle[4]",
                        "colWidth": 8,
                        "answer":""
                     },
                     {
                        "main":"Considerably harder than the contralateral (corresponding) normal testicle",
                        "dbqName":"F[0].Page_5[0].LeftTesticle[3]",
                        "colWidth": 12,
                        "answer":""
                     },
                     {
                        "main":"Considerably softer than the contralateral (corresponding) normal testicle",
                        "dbqName":"F[0].Page_5[0].LeftTesticle[2]",
                        "colWidth": 12,
                        "answer":""
                     },
                     {
                        "main":"Absent",
                        "dbqName":"F[0].Page_5[0].LeftTesticle[1]",
                        "colWidth": 4,
                        "answer":""
                     },
                     {
                        "main":"Other abnormality",
                        "dbqName":"F[0].Page_5[0].LeftTesticle[0]",
                        "colWidth": 4,
                        "subItemLinked": true,
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Left Testicle physical exam",
                  "subItemOther": false,
                  "textOther": "",
                  "dbqNameOther": "F[0].Page_5[0].TextField35[2]",
                  "placeholderOther":"Describe other abnormality",
               }                       
            ],
            "answer":""
   },
   {
      "question":"Physical Exam-Epididymis",
      "sub":'A physical exam is not required. Select "Not examined, exam not relevant to condition" if you wish to skip.',
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "5",
         title: "PHYSICAL EXAM",
         number: "7C"
      },
      "questions":[
               {
                  "main":"Normal",
                  "dbqName":"F[0].Page_5[0].EPIDIDYMIS[4]",
                  "answer":"",
                  "multi": false,
                  "radioGroup":"F[0].Page_5[0].RadioButtonList[1]",
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"Right",
                        "dbqName":"1",
                        "colWidth": 6,
                        "answer":""
                     },
                     {
                        "main":"Left",
                        "dbqName":"2",
                        "colWidth": 6,
                        "answer":""
                     },
                     {
                        "main":"Both",
                        "dbqName":"3",
                        "colWidth": 6,
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Penis physical exam",
               },
               {
                  "main":"Not examined per Veteran's request",
                  "dbqName":"F[0].Page_5[0].EPIDIDYMIS[3]",
                  "answer":"",
               },
               {
                  "main":"Not examined, testicular exam not relevant to condition",
                  "dbqName":"F[0].Page_5[0].EPIDIDYMIS[1]",
                  "answer":"",
               },
               {
                  "main":"Not examined, Veteran reports normal anatomy with no testicular deformity or abnormality",
                  "dbqName":"F[0].Page_5[0].EPIDIDYMIS[2]",
                  "answer":"",
               },
               {
                  "main":"Abnormal Right Epididymis",
                  "dbqName":"F[0].Page_5[0].EPIDIDYMIS[0]",
                  "answer":"",
                  "multi": true,
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"Tender tp palpation",
                        "dbqName":"F[0].Page_5[0].Rightepididymis[0]",
                        "colWidth": 6,
                        "answer":""
                     },
                     {
                        "main":"Other abnormality",
                        "dbqName":"F[0].Page_5[0].Rightepididymis[1]",
                        "colWidth": 6,
                        "subItemLinked": true,
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Right Testicle physical exam",
                  "subItemOther": false,
                  "textOther": "",
                  "dbqNameOther": "F[0].Page_5[0].TextField35[1]",
                  "placeholderOther":"Describe other abnormality",
               },
               {
                  "main":"Abnormal Left Epididymis",
                  "dbqName":"F[0].Page_5[0].EPIDIDYMIS[0]",
                  "answer":"",
                  "multi": true,
                  "showSubItems": false,
                  "subItems": [
                     {
                        "main":"Tender to palpation",
                        "dbqName":"F[0].Page_5[0].Leftepididymis[0]",
                        "colWidth": 6,
                        "answer":""
                     },
                     {
                        "main":"Other abnormality",
                        "dbqName":"F[0].Page_5[0].Leftepididymis[1]",
                        "colWidth": 6,
                        "subItemLinked": true,
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Left Testicle physical exam",
                  "subItemOther": false,
                  "textOther": "",
                  "dbqNameOther": "F[0].Page_5[0].TextField35[0]",
                  "placeholderOther":"Describe other abnormality",
               }                       
            ],
            "answer":""
   },
   {
      "question":"Physical Exam-Prostate",
      "sub":'A physical exam is not required. Select "Not examined, exam not relevant to condition" if you wish to skip.',
      "type":"radioTiles",
      "multi": false,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "5",
         title: "PHYSICAL EXAM",
         number: "7D"
      },
      "questions":[
         {
            "main":"Normal",
            "dbqName":"F[0].Page_5[0].PROSTATE[0]",
            "answer":""
         },
         {
            "main":"Not examined per Veteran's request",
            "dbqName":"F[0].Page_5[0].PROSTATE[1]",
            "answer":""
         },
         {
            "main":"Not examined; prostate exam not relevant to condition",
            "dbqName":"F[0].Page_5[0].PROSTATE[2]",
            "answer":""
         }, 
         {
            "main":"Abnormal",
            "dbqName":"F[0].Page_5[0].PROSTATE[3]",
            "answer":"",
            "textarea": true,
            "maxLength":100,
            "textdbqName" : "F[0].Page_5[0].TextField34[0]",
            "placeholder": "If abnormal, describe",
            "textAnswer": ""
         },          
      ],
      "answer":""
   },


   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "maxLength":105,
      "type":"textarea",
      "show": true,
      "section": {
         page: "7",
         title: "REMARKS",
         number: "12A"
      },
      "options":[],
      "dbqName":"F[0].NEWPAGE[0].ProstateCA[0].TextField47[0]",
      "answer":""
   }
]

export default Hip_questions;